<template>
  <v-dialog v-model="isDialogVisible" max-width="850">
    <v-card class="prompts-dialog">
      <v-btn class="button-close ma-4" icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <h4 class="mt-1 mr-10" style="word-break: normal;" v-if="title && title!==content">{{ title }}</h4>
      </v-card-title>
      <v-card-text>
        <div class="d-flex mt-7">
          <v-textarea v-model="content" counter readonly outlined dense class="_mr-3" :rows="15">
          </v-textarea>
        </div>
        <div class="d-flex justify-end mt-2 mb-3" >
          <v-btn @click="close()" color="primary" outlined class="mr-3">Отменить</v-btn>
          <v-btn @click="save()" color="primary" :disabled="!content">Использовать</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  name: 'PromptEditDialog',
  components: {
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: Boolean,
    title: String,
    content: String,
  },
  data: () => ({
  }),
  watch: {
    async value(val) {
      if (val) {
      }
    },
  },
  computed: {
    ...mapGetters({
      loading: 'ai/expert/loading',
    }),
    isDialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.close()
        }
      },
    },
  },
  methods: {
    ...mapActions({
      editPromptUser: 'ai/prompts/editPromptUser',
    }),
    close(ret) {
      this.$emit('input', ret);
    },
    async save(ret) {
      this.$emit('ok')
      this.close()
    },
  }
}
</script>

<style>

</style>
